import app_config from '@/app_config'

// const API_URL = app_config.api_url
// const AUTH_URL = app_config.auth_url

let API_URL, AUTH_URL, FIELD, SITE_URL

if(app_config.mode === 'dev'){
  API_URL = app_config.dev_url
  AUTH_URL = app_config.dev_auth_url
  FIELD = app_config.field_dev
  SITE_URL = app_config.dev_site_url
} else{
  API_URL = app_config.api_url
  AUTH_URL = app_config.auth_url
  FIELD = app_config.field
  SITE_URL = app_config.site_url
}

export default {
  API_URL,
  AUTH_URL,
  FIELD,
  SITE_URL,
  checkTrack: (domain, deal_id) => { return `${API_URL}/upstat?domain=${domain}&deal=${deal_id}` },
  authURL: (token, domain) => { return `${AUTH_URL}?domain=${domain}&token=${token}` },
  getSettings: `${API_URL}/settings2`,
  saveSettings: `${API_URL}/settings2`,
  saveStages: `${API_URL}/stages`,
  getStages: `${API_URL}/stages`,
  saveAlerts: `${API_URL}/deal_alert`,
  getAlerts: `${API_URL}/deal_alert`,
  saveField: `${API_URL}/field`,
  startCheck: `${API_URL}/upstat`,
  getUserBalance: `${API_URL}/user`,
  getPayAccount: (summ, id) => { return `${API_URL}/pay/account?sum=${summ}&id=${id}` },
  getPayRobo: (summ) => { return `${API_URL}/pay/robo?sum=${summ}` }
}


